import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import HeaderBread from "../../../../../../components/HeaderBread";
import CustomHeaderTitle from "../../../../../../components/constants/CustomHeaderTitle";
import Layout from "../../../../../../Layout";
import EntertainmentMenuItemInput from "../../../../../../components/EntertainmentMenuItemInput";
import { useDataLayerValue } from "../../../../../../DataLayer/DataLayer";
import {
  getEntertainmentRvc,
  getEntertainmentItemizers,
  getEntertainmentMenuItem,
} from "../../../../../../utils/ApiCalls/BackOffice/Entertainment";

const LIST_PATH = "/shore/back-office/entertainment/revenue-center";

const EditMenuItem = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [rvc, setRvc] = useState(null);
  const [itemizers, setItemizers] = useState([]);
  const [menuItem, setMenuItem] = useState(null);
  const [, dispatch] = useDataLayerValue();

  useEffect(() => {
    const loadData = async () => {
      dispatch({ type: "SET_LOADING", loading: true });
      const [rvcData, menuItemData] = await Promise.all([
        getEntertainmentRvc(params.id),
        getEntertainmentMenuItem(params.menuItemId),
      ]);
      if (!rvcData.error) {
        setRvc(rvcData);
        const itemizersRes = await getEntertainmentItemizers({
          rvcId: rvcData.id,
          limit: 1000,
        });
        if (!itemizersRes.error) setItemizers(itemizersRes.data || []);
      }
      if (!menuItemData.error) setMenuItem(menuItemData);
      dispatch({ type: "SET_LOADING", loading: false });
    };
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id, params.menuItemId]);

  const basePath = `${LIST_PATH}/${params.id}`;

  const navigation = [
    { title: "Home", route: "/" },
    { title: "Revenue Center", route: LIST_PATH },
    { title: rvc?.name || "Revenue Center", route: basePath },
    { title: "Edit Menu Item", route: `${basePath}/menu-item/edit/${params.menuItemId}` },
  ];

  return (
    <Layout type={"update_per"} module_data={"Revenue Center"}>
      <CustomHeaderTitle title={"Edit Menu Item"} />
      <HeaderBread navigation={navigation} title={"Edit Menu Item"}></HeaderBread>
      {menuItem?.isActive !== 1 && (
        <div className="container-fluid">
          <div className="alert alert-secondary" role="alert">
            This menu item is deactivated - showing a read-only view.
          </div>
        </div>
      )}
      {rvc && menuItem && (
        <EntertainmentMenuItemInput
          rvcId={rvc.id}
          rvcName={rvc.name}
          itemizers={itemizers}
          menuItem={menuItem}
          readOnly={menuItem?.isActive !== 1}
          onSuccess={() =>
            navigate(basePath, { state: { topTab: "menuItem" } })
          }
        />
      )}
    </Layout>
  );
};

export default EditMenuItem;
